import { render, staticRenderFns } from "./AlertDialogDocumentUpload.vue?vue&type=template&id=04ff6bee&scoped=true&lang=pug&"
import script from "./AlertDialogDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./AlertDialogDocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./AlertDialogDocumentUpload.vue?vue&type=style&index=0&id=04ff6bee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff6bee",
  null
  
)

export default component.exports